import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Natarajasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Natarajasana.title1"), context: t("Natarajasana.context1") },
      { title: t("Natarajasana.title2"), context: t("Natarajasana.context2") },
      { title: t("Natarajasana.title3"), context: t("Natarajasana.context3") },
      { title: t("Natarajasana.title4"), context: t("Natarajasana.context4") },
      { title: t("Natarajasana.title5"), context: t("Natarajasana.context5") },
      { title: t("Natarajasana.title6"), context: t("Natarajasana.context6") },
      { title: t("Natarajasana.title7"), context: t("Natarajasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Natarajasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Natarajasana.mp4'}
                title="Description"
                context={t("Natarajasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Natarajasana
